import FeaturesMap from '@apps-common/ui-maps/FeaturesMap.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import {Alert, Box, useTheme} from '@mui/material';
import {GeojsonLayer} from '@apps-common/ui-maps';
import {useGetUploadCollection} from '@api/asyncIngest';

const ReviewCollection = ({upload}) => {
  const theme = useTheme();
  const {data: collection, error, isPending} = useGetUploadCollection({upload});

  return (
    <>
      {error && <Alert severity="error">{error.message}</Alert>}
      {!collection && isPending && <Alert severity="info">Loading...</Alert>}
      {!error && !!collection && (
        <Box sx={{height: '300px', width: '100%'}}>
          <FeaturesMap
            features={
              collection?.features?.length
                ? collection.features.map(f => ({type: 'Feature', ...f}))
                : []
            }
            animationDuration={0}
          >
            <GeojsonLayer
              features={[]}
              style={[
                {
                  'stroke-width': 5,
                  'stroke-color': theme.palette.secondary.light,
                },
                {
                  'stroke-width': 3,
                  'stroke-color': theme.palette.secondary.main,
                },
              ]}
            />
          </FeaturesMap>
        </Box>
      )}
    </>
  );
};

ReviewCollection.propTypes = {
  upload: PropTypes.object,
};

export default ReviewCollection;
